import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { askRedo } from "./schema/ask-redo";
import { connectChargebacksStripe } from "./schema/chargebacks/connect-chargebacks-stripe";
import { enableChargebacksBilling } from "./schema/chargebacks/enable-chargebacks-billing";
import { exchangeShopifyOAuthCode } from "./schema/chargebacks/exchange-shopify-oauth-code";
import { getChargebacksGorgiasAuthUrl } from "./schema/chargebacks/get-chargebacks-gorgias-auth-url";
import { getChargebacksInsights } from "./schema/chargebacks/get-chargebacks-insights";
import { getChargebacksPaypalAuthUrl } from "./schema/chargebacks/get-chargebacks-paypal-auth-url";
import { getChargebacksProviderStatus } from "./schema/chargebacks/get-chargebacks-provider-status";
import { getChargebacksScopeStatus } from "./schema/chargebacks/get-chargebacks-scope-status";
import { completeOnboarding } from "./schema/complete-onboarding";
import { getAppEmbedStatus } from "./schema/get-app-embed-status";
import { getProgress } from "./schema/get-progress";
import { getResumeState } from "./schema/get-resume-state";
import { initialize } from "./schema/initialize";
import { enableRecoverBilling } from "./schema/recover/enable-recover-billing";
import { getRecoverRevenueEstimate } from "./schema/recover/get-recover-revenue-estimate";
import { provisionRecoverPhoneNumber } from "./schema/recover/provision-recover-phone-number";
import { saveTeamProfileFields } from "./schema/recover/save-team-profile-fields";
import { aiReturnReasons } from "./schema/returns/ai-return-reasons";
import { analyzePolicy } from "./schema/returns/analyze-policy";
import {
  createBillingSetupIntent,
  getBillingStatus,
  saveBillingPaymentMethod,
} from "./schema/returns/billing";
import { getExclusionOptions } from "./schema/returns/get-exclusion-options";
import { getGoogleMapsKey } from "./schema/returns/get-google-maps-key";
import { getStoreProducts } from "./schema/returns/get-store-products";
import { saveProgress } from "./schema/save-progress";

export const rpcDefinition = {
  askRedo,
  connectChargebacksStripe,
  enableChargebacksBilling,
  enableRecoverBilling,
  exchangeShopifyOAuthCode,
  getRecoverRevenueEstimate,
  provisionRecoverPhoneNumber,
  saveTeamProfileFields,
  getChargebacksGorgiasAuthUrl,
  getChargebacksInsights,
  getChargebacksPaypalAuthUrl,
  getChargebacksProviderStatus,
  getChargebacksScopeStatus,
  aiReturnReasons,
  analyzePolicy,
  createBillingSetupIntent,
  completeOnboarding,
  getAppEmbedStatus,
  getBillingStatus,
  getExclusionOptions,
  getGoogleMapsKey,
  getProgress,
  getResumeState,
  getStoreProducts,
  initialize,
  saveBillingPaymentMethod,
  saveProgress,
};

export type RedoOnboardingV2RpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
